
export default (state, id) => state.followerGroups.followerGroups.find((fg) => fg.id === id);
